import clsx from 'clsx';
import type { SelectHTMLAttributes, ReactNode } from 'react';

export function Select({
  className,
  children,
  ...rest
}: SelectHTMLAttributes<HTMLSelectElement> & { children: ReactNode }) {
  return (
    <select
      className={clsx(
        'w-full min-h-tap rounded-md border border-border-token bg-surface-raised',
        'px-3.5 py-2.5 text-sm text-content',
        'focus:outline-none focus:ring-2 focus:ring-accent focus:border-accent',
        'disabled:opacity-50',
        className,
      )}
      {...rest}
    >
      {children}
    </select>
  );
}
